import React from 'react'
import { useNavigate } from 'react-router-dom'

const NotFound = () => {
    const navigate = useNavigate()
  return (
    <div class='d-flex align-items-center justify-content-center' style={{height:'100vh', width:'100%'}}>
        <div>
            <p class='display-1 org fw-bold'>404</p>
            <p class='fs-4'>Page Not Found</p>
            <button className="buttonEffect mb-2" onClick={()=>navigate('/')} >Go to Home</button>

        </div>
        
    </div>
  )
}

export default NotFound